import { Project } from '../types/project';

export const projects: Project[] = [
  {
    id: 1,
    title: "Samsung Electronics EO Retail Guide Pilot Store",
    category: "Guideline",
    date: "2023",
    location: "London, United Kingdom",
    description: "Design and construction of Samsung Electronics EO Retail Guide Pilot Store",
    image: "/images/optimized-images/arch-pro/01_SS_EO_Retail_Guide_Pilot_Store/04.webp",
    imageFiles: ["03.png", "04.png", "05.png", "06.png"],
    tags: ["Retail Strategy", "Store Opening Coordination", "Guideline Development", "Project Reporting"],
    isStudent: false,
    isComputer: false,
    additionalImages: [
      "/images/optimized-images/arch-pro/01_SS_EO_Retail_Guide_Pilot_Store/03.webp",
      "/images/optimized-images/arch-pro/01_SS_EO_Retail_Guide_Pilot_Store/05.webp",
      "/images/optimized-images/arch-pro/01_SS_EO_Retail_Guide_Pilot_Store/06.webp"
    ]
  },
  {
    id: 2,
    title: "LG Event - East Coast Radio Show",
    category: "Event",
    date: "2022",
    location: "Durban, South Africa",
    description: "Design and construction of LG Event booth at East Coast Radio Show",
    image: "/images/optimized-images/arch-pro/02_LG_Event_East_Coast_Radio_Show/08.webp",
    imageFiles: ["07.png", "08.png", "09.png"],
    tags: ["Event Planning", "Timeline Management", "Vendor Management", "On-site Coordination"],
    isStudent: false,
    isComputer: false,
    additionalImages: [
      "/images/optimized-images/arch-pro/02_LG_Event_East_Coast_Radio_Show/07.webp",
      "/images/optimized-images/arch-pro/02_LG_Event_East_Coast_Radio_Show/09.webp"
    ]
  },
  {
    id: 3,
    title: "LG Shop-in-Shop Hirschs Waterfall",
    category: "Shop-in-Shop",
    date: "2022",
    location: "Johannesburg, South Africa",
    description: "Design and construction of LG Shop-in-Shop at Hirschs Waterfall",
    image: "/images/optimized-images/arch-pro/03_LG_Shop-in-Shop_Hirschs_Waterfall/11.webp",
    imageFiles: ["10.png", "11.png", "12.png", "13.png", "14.png"],
    tags: ["Shop-in-Shop", "Construction Scheduling", "Vendor Management", "Fixture Installation"],
    isStudent: false,
    isComputer: false,
    additionalImages: [
      "/images/optimized-images/arch-pro/03_LG_Shop-in-Shop_Hirschs_Waterfall/10.webp",
      "/images/optimized-images/arch-pro/03_LG_Shop-in-Shop_Hirschs_Waterfall/12.webp",
      "/images/optimized-images/arch-pro/03_LG_Shop-in-Shop_Hirschs_Waterfall/13.webp",
      "/images/optimized-images/arch-pro/03_LG_Shop-in-Shop_Hirschs_Waterfall/14.webp"
    ]
  },
  {
    id: 4,
    title: "LG Shop-in-Shop Stax Woodlands",
    category: "Shop-in-Shop",
    date: "2021",
    location: "Pretoria, South Africa",
    description: "Design and construction of LG Shop-in-Shop at Stax Woodlands",
    image: "/images/optimized-images/arch-pro/04_LG_Shop-in-Shop_Stax_Woodlands/16.webp",
    imageFiles: ["15.png", "16.png", "17.png"],
    tags: ["Shop-in-Shop", "Site Supervision", "Fixture Installation", "Kick-off Meeting Facilitation"],
    isStudent: false,
    isComputer: false,
    additionalImages: [
      "/images/optimized-images/arch-pro/04_LG_Shop-in-Shop_Stax_Woodlands/15.webp",
      "/images/optimized-images/arch-pro/04_LG_Shop-in-Shop_Stax_Woodlands/17.webp"
    ]
  },
  {
    id: 5,
    title: "LG Shop-in-Shop Tuskys T-Mall",
    category: "Shop-in-Shop",
    date: "2018",
    location: "Nairobi, Kenya",
    description: "Design and construction of LG Shop-in-Shop at Tuskys T-Mall",
    image: "/images/optimized-images/arch-pro/05_LG_Shop-in-Shop_Tuskys_T-Mall/19.webp",
    imageFiles: ["18.png", "19.png", "20.png", "21.png"],
    tags: ["Shop-in-Shop", "Retail Operations", "Procurement", "Stakeholder Communication"],
    isStudent: false,
    isComputer: false,
    additionalImages: [
      "/images/optimized-images/arch-pro/05_LG_Shop-in-Shop_Tuskys_T-Mall/18.webp",
      "/images/optimized-images/arch-pro/05_LG_Shop-in-Shop_Tuskys_T-Mall/20.webp",
      "/images/optimized-images/arch-pro/05_LG_Shop-in-Shop_Tuskys_T-Mall/21.webp"
    ]
  },
  {
    id: 6,
    title: "LG Shop-in-Shop Plugin Dubai",
    category: "Shop-in-Shop",
    date: "2017",
    location: "Dubai, United Arab Emirates",
    description: "Design and construction of LG Shop-in-Shop at Plugin Dubai Festival City",
    image: "/images/optimized-images/arch-pro/06_LG_Shop-in-Shop_Plugin_Dubai/23.webp",
    imageFiles: ["22.png", "23.png", "24.png", "25.png"],
    tags: ["Shop-in-Shop", "International Coordination", "Logistics", "Daily Progress Updates"],
    isStudent: false,
    isComputer: false,
    additionalImages: [
      "/images/optimized-images/arch-pro/06_LG_Shop-in-Shop_Plugin_Dubai/22.webp",
      "/images/optimized-images/arch-pro/06_LG_Shop-in-Shop_Plugin_Dubai/24.webp",
      "/images/optimized-images/arch-pro/06_LG_Shop-in-Shop_Plugin_Dubai/25.webp"
    ]
  },
  {
    id: 7,
    title: "Samsung Premium Brand Store Gateway",
    category: "Brand Shop",
    date: "2015",
    location: "Durban, South Africa",
    description: "Design and construction of Samsung Premium Brand Store at Gateway Mall",
    image: "/images/optimized-images/arch-pro/07_SS_Premium_Brand_Store_Gateway/27.webp",
    imageFiles: ["26.png", "27.png", "28.png", "29.png", "30.png", "31.png"],
    tags: ["Brand Shop", "Design Coordination", "Store Planning", "Stakeholder Communication"],
    isStudent: false,
    isComputer: false,
    additionalImages: [
      "/images/optimized-images/arch-pro/07_SS_Premium_Brand_Store_Gateway/26.webp",
      "/images/optimized-images/arch-pro/07_SS_Premium_Brand_Store_Gateway/28.webp",
      "/images/optimized-images/arch-pro/07_SS_Premium_Brand_Store_Gateway/29.webp",
      "/images/optimized-images/arch-pro/07_SS_Premium_Brand_Store_Gateway/30.webp",
      "/images/optimized-images/arch-pro/07_SS_Premium_Brand_Store_Gateway/31.webp"
    ]
  },
  {
    id: 8,
    title: "Samsung Galaxy Note4 Event",
    category: "Event",
    date: "2015",
    location: "Various Location, South Africa",
    description: "Design and construction of Samsung Galaxy Note4 Roadshow Exhibition Event",
    image: "/images/optimized-images/arch-pro/08_SS_Galaxy_Note4_Event/33.webp",
    imageFiles: ["32.png", "33.png", "34.png", "35.png", "36.png"],
    tags: ["Event Design", "Vendor Coordination", "On-site Execution", "Project Timeline"],
    isStudent: false,
    isComputer: false,
    additionalImages: [
      "/images/optimized-images/arch-pro/08_SS_Galaxy_Note4_Event/32.webp",
      "/images/optimized-images/arch-pro/08_SS_Galaxy_Note4_Event/34.webp",
      "/images/optimized-images/arch-pro/08_SS_Galaxy_Note4_Event/35.webp",
      "/images/optimized-images/arch-pro/08_SS_Galaxy_Note4_Event/36.webp"
    ]
  },
  {
    id: 9,
    title: "Samsung SES Guideline Development",
    category: "Guideline",
    date: "2015",
    location: "South Africa",
    description: "Development of Samsung SES Guidelines and Documentation",
    image: "/images/optimized-images/arch-pro/09_SS_SES_Guideline_Development/38.webp",
    imageFiles: ["37.png", "38.png", "39.png"],
    tags: ["Guideline Development", "Visual Design", "Documentation", "Brand Consistency"],
    isStudent: false,
    isComputer: false,
    additionalImages: [
      "/images/optimized-images/arch-pro/09_SS_SES_Guideline_Development/37.webp"
    ]
  },
  {
    id: 10,
    title: "Samsung Premium Mobile Store Ikeja",
    category: "Brand Shop",
    date: "2014",
    location: "Lagos, Nigeria",
    description: "Design and construction of Samsung Premium Mobile Store at Ikeja Mall",
    image: "/images/optimized-images/arch-pro/10_SS_Premium_Mobile_Store_Ikeja/41.webp",
    imageFiles: ["40.png", "41.png", "42.png", "43.png", "44.png", "45.png"],
    tags: ["Retail Strategy", "Store Launch", "Brand Implementation", "Design Management"],
    isStudent: false,
    isComputer: false,
    additionalImages: [
      "/images/optimized-images/arch-pro/10_SS_Premium_Mobile_Store_Ikeja/40.webp",
      "/images/optimized-images/arch-pro/10_SS_Premium_Mobile_Store_Ikeja/42.webp",
      "/images/optimized-images/arch-pro/10_SS_Premium_Mobile_Store_Ikeja/43.webp",
      "/images/optimized-images/arch-pro/10_SS_Premium_Mobile_Store_Ikeja/44.webp",
      "/images/optimized-images/arch-pro/10_SS_Premium_Mobile_Store_Ikeja/45.webp"
    ]
  },
  {
    id: 11,
    title: "Samsung Show Window Display",
    category: "Show Window Display",
    date: "2013",
    location: "Johannesburg, South Africa",
    description: "Design and construction of Samsung Show Window Display",
    image: "/images/optimized-images/arch-pro/11_SS_Show_Window_Display/47.webp",
    imageFiles: ["46.png", "47.png", "48.png", "49.png", "50.png"],
    tags: ["Visual Merchandising", "Show Window Design", "Branding", "Layout Planning"],
    isStudent: false,
    isComputer: false,
    additionalImages: [
      "/images/optimized-images/arch-pro/11_SS_Show_Window_Display/46.webp",
      "/images/optimized-images/arch-pro/11_SS_Show_Window_Display/48.webp",
      "/images/optimized-images/arch-pro/11_SS_Show_Window_Display/49.webp",
      "/images/optimized-images/arch-pro/11_SS_Show_Window_Display/50.webp"
    ]
  },
  {
    id: 12,
    title: "EduOcean E-learning Platform",
    category: "Web Development",
    date: "2020",
    location: "www.edu-ocean.com",
    description: "A full-featured E-learning platform built with Django and deployed on AWS.",
    descriptionText: `
      <div style="line-height: 1.7; color: #374151;">
        <p style="margin-bottom: 1rem;">
          The website is built with HTML and Python programming language on top of the Django framework. The Django framework was chosen to shorten the time it takes to develop the site considering the given timeline. Bootstrap is used for responsive layout and AWS services including EC2 and RDS were utilized for deployment.
        </p>
        
        <h3 style="font-size: 1.25rem; font-weight: 600; margin-bottom: 1rem; margin-top: 1.5rem; color: #111827;">Main Features:</h3>
        <ul style="margin-left: 1.5rem; margin-bottom: 1rem;">
          <li style="margin-bottom: 0.5rem;">Assignment Updates: Announcement and downloadable materials uploaded weekly.</li>
          <li style="margin-bottom: 0.5rem;">Study Materials: Video lectures (via YouTube iframe) and audio files for speaking practice.</li>
          <li style="margin-bottom: 0.5rem;">Vocabulary Test: Flashcard-style quizzes with performance tracking.</li>
          <li style="margin-bottom: 0.5rem;">Test Score & Progress: Shows user and group averages to motivate.</li>
          <li style="margin-bottom: 0.5rem;">Assignment Submission: Submit written/audio tasks, progress bar updated.</li>
          <li style="margin-bottom: 0.5rem;">Tutor Comments: 1:1 communication with tutor, no peer messaging.</li>
          <li style="margin-bottom: 0.5rem;">Vocabulary Test Page: Randomized flashcards, records latest scores for analysis.</li>
        </ul>
      </div>
    `,
    image: "/images/optimized-images/web-dev/edu-ocean/01.webp",
    imageFiles: ["01.png", "02.png", "03.png"],
    tags: [
      "Django", "Python", "Bootstrap", "AWS EC2", "AWS RDS", "MySQL",
      "Responsive Design", "Flash Card Test", "Progress Tracker"
    ],
    isStudent: false,
    isComputer: true,
    additionalImages: [
      "/images/optimized-images/web-dev/edu-ocean/02.webp",
      "/images/optimized-images/web-dev/edu-ocean/03.webp"
    ]
  },
  {
    id: 13,
    title: "Evaluating the Effectiveness of a Customised E-learning Platform",
    category: "Data Analysis",
    date: "2020",
    location: "United Kingdom",
    description: "Analyzed learner engagement and academic outcomes on two e-learning platforms during COVID-19.",
    descriptionText: `
      <div style="line-height: 1.7; color: #374151;">
        <p style="margin-bottom: 1rem;">
          This research project explored the effectiveness of a Django-based e-learning platform compared to KakaoTalk, a popular messaging app, for online language study groups during the COVID-19 pandemic.
          Over 100 participants engaged in English and Chinese lessons across three months, and their behaviors were analyzed using chat logs, test results, and assignment completion data.
        </p>
    
        <h3 style="font-size: 1.25rem; font-weight: 600; margin-bottom: 1rem; margin-top: 1.5rem; color: #111827;">Main Hypotheses:</h3>
        <ul style="margin-left: 1.5rem; margin-bottom: 1.5rem;">
          <li style="margin-bottom: 0.5rem;">h1: Tutor's feedback increases engagement</li>
          <li style="margin-bottom: 0.5rem;">h2: Peer communication increases engagement</li>
          <li style="margin-bottom: 0.5rem;">h3: Platform functions impact engagement</li>
          <li style="margin-bottom: 0.5rem;">h4: Engagement correlates with academic achievement</li>
        </ul>
    
        <h3 style="font-size: 1.25rem; font-weight: 600; margin-bottom: 1rem; margin-top: 1.5rem; color: #111827;">Key Findings:</h3>
        <ul style="margin-left: 1.5rem; margin-bottom: 1.5rem;">
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">h2 and h4 were supported</strong>: Peer interaction strongly influenced engagement and academic outcomes.</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">h1 and h3 were not fully confirmed</strong>, suggesting communication features were more critical than tutor feedback or platform design.</li>
          <li style="margin-bottom: 0.5rem;">Despite the customised platform being preferred for its structure and feedback archiving, the open communication in KakaoTalk led to higher assignment completion.</li>
        </ul>
    
        <p style="margin-bottom: 0;">
          <strong style="font-weight: 600;">Skills demonstrated:</strong> Data analysis, experimental design, user behavior tracking, full-stack web development, visualization.
        </p>
      </div>
    `,
    image: "/images/optimized-images/data-analysis/elearning-effectiveness/01.webp",
    imageFiles: ["01.png", "02.png", "03.png", "04.png", "05.png", "06.png", "07.png", "08.png", "09.png", "10.png", "11.png", "12.png"],
    tags: [
      "Data Analysis", "User Behavior", "Education Research", "Django",
      "KakaoTalk", "Flashcard Quiz", "Experimental Design", "COVID-19", "Python"
    ],
    isStudent: false,
    isComputer: true,
    additionalImages: [
      "/images/optimized-images/data-analysis/elearning-effectiveness/02.webp",
      "/images/optimized-images/data-analysis/elearning-effectiveness/03.webp",
      "/images/optimized-images/data-analysis/elearning-effectiveness/04.webp",
      "/images/optimized-images/data-analysis/elearning-effectiveness/05.webp",
      "/images/optimized-images/data-analysis/elearning-effectiveness/06.webp",
      "/images/optimized-images/data-analysis/elearning-effectiveness/07.webp",
      "/images/optimized-images/data-analysis/elearning-effectiveness/08.webp",
      "/images/optimized-images/data-analysis/elearning-effectiveness/09.webp",
      "/images/optimized-images/data-analysis/elearning-effectiveness/10.webp",
      "/images/optimized-images/data-analysis/elearning-effectiveness/11.webp",
      "/images/optimized-images/data-analysis/elearning-effectiveness/12.webp"
    ]
  },
  {
    id: 14,
    title: "Website Traffic Analytics Report",
    category: "Data Analysis",
    date: "2020",
    location: "London, United Kingdom",
    description: "A detailed analytics report visualizing website traffic trends(edu-ocean.com), sources, and user behavior across a 6-month period.",
    descriptionText: `
      <div style="line-height: 1.7; color: #374151;">
        <p style="margin-bottom: 1rem;">
          This project showcases a customized website analytics report built with HTML, based on Google Analytics and behavioral data tracking.
          It visualizes performance metrics such as page views, bounce rates, traffic sources, device types, and time-on-site across multiple charts.
        </p>
        
        <p style="margin-bottom: 1rem;">
          Key metrics covered include:
        </p>
        <ul style="margin-left: 1.5rem; margin-bottom: 1.5rem;">
          <li style="margin-bottom: 0.5rem;">Total visits and unique visitors over time</li>
          <li style="margin-bottom: 0.5rem;">Breakdown of traffic sources: Organic, Direct, Referral, Social</li>
          <li style="margin-bottom: 0.5rem;">Top-performing pages by conversion rate</li>
          <li style="margin-bottom: 0.5rem;">Time and day of week analysis for peak user activity</li>
          <li style="margin-bottom: 0.5rem;">New vs. returning visitor ratios</li>
        </ul>
        
        <p style="margin-bottom: 1.5rem;">
          This standalone HTML report demonstrates skills in data visualization, frontend integration (Chart.js), and interpreting user engagement insights to guide marketing and UX strategy.
        </p>
        
        <div style="margin-top: 2rem;">
          <iframe
            src="/assets/data_analytics_for_website.html"
            width="100%"
            height="800"
            style="border: 1px solid #ccc; border-radius: 0.5rem;"
            title="Website Analytics Report"
          ></iframe>
        </div>
      </div>
    `,
    image: "/images/optimized-images/data-analysis/web-analytics/01.webp",
    imageFiles: ["01.png", "02.png", "03.png", "04.png"],
    tags: ["Data Visualization", "Google Analytics", "Chart.js", "Traffic Sources", "User Behavior"],
    isStudent: false,
    isComputer: true,
    additionalImages: [
      "/images/optimized-images/data-analysis/web-analytics/02.webp",
      "/images/optimized-images/data-analysis/web-analytics/03.webp",
      "/images/optimized-images/data-analysis/web-analytics/04.webp"
    ]
  },
  {
    id: 15,
    title: "Data Analytics on KakaoTalk-Based Language Learning",
    category: "Data Analysis",
    date: "2020",
    location: "London, United Kingdom",
    description: "Analyzed learner engagement through chat data and task completion within KakaoTalk-based study groups.",
    descriptionText: `
      <div style="line-height: 1.7; color: #374151;">
        <p style="margin-bottom: 1rem;">
          This project focused on analyzing user behavior in online language learning environments using KakaoTalk as the main platform. The analysis included chat message frequency, assignment submission rates, and test scores to evaluate engagement and academic outcomes.
        </p>
    
        <h3 style="font-size: 1.25rem; font-weight: 600; margin-bottom: 1rem; margin-top: 1.5rem; color: #111827;">Key Focus Areas:</h3>
        <ul style="margin-left: 1.5rem; margin-bottom: 1.5rem;">
          <li style="margin-bottom: 0.5rem;">Correlation between number of messages and engagement score (E-Score)</li>
          <li style="margin-bottom: 0.5rem;">Impact of peer communication on assignment completion</li>
          <li style="margin-bottom: 0.5rem;">Data visualization using bar graphs and scatter plots</li>
        </ul>
    
        <p style="margin-bottom: 1rem;">
          Results confirmed that active peer-to-peer messaging was strongly linked to engagement. Study groups using KakaoTalk demonstrated higher assignment completion compared to groups without active communication. 
        </p>
    
        <p style="margin-bottom: 1.5rem;">
          <strong style="font-weight: 600;">Skills demonstrated:</strong> Chat log analysis, metric design (E-Score), hypothesis testing, data visualization, engagement analytics.
        </p>
        
        <div style="margin-top: 2rem;">
          <iframe
            src="/assets/data_analytics_for_KakaoTalk.html"
            width="100%"
            height="800"
            style="border: 1px solid #ccc; border-radius: 0.5rem;"
            title="Website Analytics Report"
          ></iframe>
        </div>
      </div>
    `,
    image: "/images/optimized-images/data-analysis/kakaotalk-effectiveness/01.webp",
    imageFiles: ["01.png", "02.png", "03.png", "04.png"],
    tags: [
      "KakaoTalk", "Engagement Metrics", "E-Score", "Chat Log Analysis", "Education Analytics",
      "Scatter Plot", "Bar Chart", "User Behavior", "COVID-19"
    ],
    isStudent: false,
    isComputer: true,
    additionalImages: [
      "/images/optimized-images/data-analysis/kakaotalk-effectiveness/02.webp",
      "/images/optimized-images/data-analysis/kakaotalk-effectiveness/03.webp",
      "/images/optimized-images/data-analysis/kakaotalk-effectiveness/04.webp"
    ]
  },
  {
    id: 16,
    title: "Email Marketing Dashboard and Performance Analysis",
    category: "Data Analysis",
    date: "2024",
    location: "United Kingdom",
    description: "Built a dashboard to analyze email campaign performance using open/click rates, unsubscribe behavior, and engagement trends.",
    descriptionText: `
      <div style="line-height: 1.7; color: #374151;">
        <p style="margin-bottom: 1rem;">
          This project showcases a data dashboard built to analyze over 1 year of email marketing campaign performance.
          Key indicators such as open rates, click rates, unsubscribe behavior, and subscriber growth were visualized
          to help identify what content resonated best with the audience.
        </p>
    
        <h3 style="font-size: 1.25rem; font-weight: 600; margin-bottom: 1rem; margin-top: 1.5rem; color: #111827;">Key Features:</h3>
        <ul style="margin-left: 1.5rem; margin-bottom: 1.5rem;">
          <li style="margin-bottom: 0.5rem;">Week-by-week performance breakdown (opens, clicks, net subscribers)</li>
          <li style="margin-bottom: 0.5rem;">Monthly click-through and open rate tracking</li>
          <li style="margin-bottom: 0.5rem;">Campaign-level insights by subject line and content tag</li>
        </ul>
    
        <p style="margin-bottom: 1rem;">
          The dashboard provided clear visibility into what topics and formats led to higher user engagement, 
          and informed content planning for future newsletters.
        </p>
    
        <p style="margin-bottom: 1.5rem;">
          <strong style="font-weight: 600;">Skills demonstrated:</strong> CSV parsing, time-series aggregation, data visualization (bar/line chart),
          user segmentation, HTML embedding.
        </p>
    
        <div style="margin-top: 2rem;">
          <iframe
            src="/assets/data_analytics_for_email.html"
            width="100%"
            height="800"
            style="border: 1px solid #ccc; border-radius: 0.5rem;"
            title="Email Marketing Analytics Report"
          ></iframe>
        </div>
      </div>
    `,
    image: "/images/optimized-images/data-analysis/email-dashboard/01.webp",
    imageFiles: ["01.webp"],
    tags: [
      "Email Marketing", "Newsletter", "Open Rate", "Click Rate",
      "Engagement", "Subscriber Growth", "Dashboard", "Data Visualization"
    ],
    isStudent: false,
    isComputer: true,
    additionalImages: [
      "/images/optimized-images/data-analysis/email-dashboard/02.webp"
    ]
  },
  {
    id: 17,
    title: "Dwriting.ai - AI-Powered Writing Practice Platform",
    category: "Web Development",
    date: "2025",
    location: "Woking, United Kingdom",
    description: "A production-ready full-stack web application with AI-powered personalized feedback, serving real users with complex statistical analysis and machine learning-based evaluation systems.",
    descriptionText: `
      <div style="line-height: 1.7; color: #374151;">
        <h1 style="font-size: 2rem; font-weight: 700; margin-bottom: 1.5rem; color: #111827;">Dwriting.ai — AI Writing Coach Platform</h1>
        
        <p style="margin-bottom: 1rem;">
          A full-stack AI writing platform I architected and built end-to-end — from AI coaching engine and peer feedback system to subscription billing — serving 200+ registered users across Korean and English.
        </p>
        
        <p style="margin-bottom: 2rem;">
          Unlike AI writing tools that generate text for users, Dwriting coaches users to write better themselves through a 3-stage collaborative workflow (context → outline → draft → revision), personalized style learning, and peer feedback loops.
        </p>

        <hr style="border: none; border-top: 1px solid #e5e7eb; margin: 2rem 0;" />

        <h2 style="font-size: 1.5rem; font-weight: 700; margin-bottom: 1.5rem; margin-top: 2rem; color: #111827;">Key Achievements</h2>
        
        <div style="margin-bottom: 1.5rem;">
          <p style="margin-bottom: 0.5rem;">
            <strong style="font-weight: 600;">AI Score Reliability</strong><br />
            AI evaluation scores showed high variance (±15 points for identical essays), undermining user trust in feedback. Implemented statistical outlier detection using standard deviation + IQR methods with adaptive score limiting. → <strong style="font-weight: 600;">Reduced score variance by 40%</strong>
          </p>
        </div>
        
        <div style="margin-bottom: 1.5rem;">
          <p style="margin-bottom: 0.5rem;">
            <strong style="font-weight: 600;">Email Delivery</strong><br />
            Welcome and feedback notification emails were failing silently at 60% delivery rate, breaking the user engagement loop. Migrated to Resend API with exponential backoff retry logic and delivery tracking. → <strong style="font-weight: 600;">Improved delivery rate from 60% to 98%</strong>
          </p>
        </div>
        
        <div style="margin-bottom: 1.5rem;">
          <p style="margin-bottom: 0.5rem;">
            <strong style="font-weight: 600;">Duplicate Prevention</strong><br />
            Users accidentally submitting the same writing twice inflated analytics and confused the feedback system. Built hash-based detection with MongoDB compound index optimization. → <strong style="font-weight: 600;">Reduced duplicate submissions by 95%</strong>
          </p>
        </div>
        
        <div style="margin-bottom: 1.5rem;">
          <p style="margin-bottom: 0.5rem;">
            <strong style="font-weight: 600;">Hybrid Billing System</strong><br />
            Integrated Polar for Pro subscription ($9.99/mo) + credit-based pay-per-use ($4.99/50 credits), with real-time balance updates — no page refresh needed after payment.
          </p>
        </div>
        
        <div style="margin-bottom: 1.5rem;">
          <p style="margin-bottom: 0.5rem;">
            <strong style="font-weight: 600;">5-Dimension AI Scoring Engine</strong><br />
            Designed a multi-dimensional evaluation algorithm scoring content, expression, structure, logic, and impact on a 100-point scale. Each dimension provides specific improvement tips, not just a number.
          </p>
        </div>
        
        <div style="margin-bottom: 1.5rem;">
          <p style="margin-bottom: 0.5rem;">
            <strong style="font-weight: 600;">AI SEO Writing Pipeline</strong><br />
            Built an end-to-end SEO content workflow: keyword suggestion → title generation → outline → draft → AI review, all within a single guided interface.
          </p>
        </div>
        
        <div style="margin-bottom: 1.5rem;">
          <p style="margin-bottom: 0.5rem;">
            <strong style="font-weight: 600;">Performance & Reliability</strong><br />
            Load-tested to handle 1,000+ concurrent users with API response time &lt; 200ms (p95). Achieved 99.9% uptime with Docker-based deployment on Railway.
          </p>
        </div>

        <hr style="border: none; border-top: 1px solid #e5e7eb; margin: 2rem 0;" />

        <h2 style="font-size: 1.5rem; font-weight: 700; margin-bottom: 1.5rem; margin-top: 2rem; color: #111827;">Technical Highlights</h2>
        
        <ul style="margin-left: 1.5rem; margin-bottom: 2rem;">
          <li style="margin-bottom: 0.75rem;">Designed personalized AI prompt generation system that adapts to individual writing patterns, history, and style profile over time</li>
          <li style="margin-bottom: 0.75rem;">Built peer feedback system with gamification logic — users must give 3 feedbacks before unlocking their own, driving community engagement</li>
          <li style="margin-bottom: 0.75rem;">Implemented full i18n (Korean/English) with browser-based auto-detection and bilingual AI topic generation</li>
          <li style="margin-bottom: 0.75rem;">Developed 70+ analysis scripts that identified key user drop-off points, directly informing UX improvements and feature prioritization</li>
          <li style="margin-bottom: 0.75rem;">Eliminated all timezone-related bugs across global users through centralized timezone utility functions</li>
          <li style="margin-bottom: 0.75rem;">Architected scalable backend with feature flags, rate limiting, and graceful error handling</li>
        </ul>

        <hr style="border: none; border-top: 1px solid #e5e7eb; margin: 2rem 0;" />

        <h2 style="font-size: 1.5rem; font-weight: 700; margin-bottom: 1.5rem; margin-top: 2rem; color: #111827;">Project Scale</h2>
        
        <table style="width: 100%; border-collapse: collapse; margin: 1.5rem 0;">
          <thead>
            <tr style="border-bottom: 2px solid #e5e7eb;">
              <th style="text-align: left; padding: 0.75rem 0; font-weight: 600; color: #111827;">Metric</th>
              <th style="text-align: left; padding: 0.75rem 0; font-weight: 600; color: #111827;">Detail</th>
            </tr>
          </thead>
          <tbody>
            <tr style="border-bottom: 1px solid #e5e7eb;">
              <td style="padding: 0.75rem 0;">Codebase</td>
              <td style="padding: 0.75rem 0;">Solo-built 15,000+ lines of production code</td>
            </tr>
            <tr style="border-bottom: 1px solid #e5e7eb;">
              <td style="padding: 0.75rem 0;">Frontend</td>
              <td style="padding: 0.75rem 0;">70+ React components with TypeScript</td>
            </tr>
            <tr style="border-bottom: 1px solid #e5e7eb;">
              <td style="padding: 0.75rem 0;">Backend</td>
              <td style="padding: 0.75rem 0;">30+ API endpoints, 10+ MongoDB models</td>
            </tr>
            <tr style="border-bottom: 1px solid #e5e7eb;">
              <td style="padding: 0.75rem 0;">Users</td>
              <td style="padding: 0.75rem 0;">200+ registered, bilingual (KR/EN)</td>
            </tr>
            <tr style="border-bottom: 1px solid #e5e7eb;">
              <td style="padding: 0.75rem 0;">Billing</td>
              <td style="padding: 0.75rem 0;">Subscription + credit hybrid via Polar</td>
            </tr>
            <tr style="border-bottom: 1px solid #e5e7eb;">
              <td style="padding: 0.75rem 0;">Deployment</td>
              <td style="padding: 0.75rem 0;">Dockerized on Railway with CI/CD</td>
            </tr>
            <tr style="border-bottom: 1px solid #e5e7eb;">
              <td style="padding: 0.75rem 0;">Analytics</td>
              <td style="padding: 0.75rem 0;">70+ data analysis scripts</td>
            </tr>
          </tbody>
        </table>

        <hr style="border: none; border-top: 1px solid #e5e7eb; margin: 2rem 0;" />

        <h2 style="font-size: 1.5rem; font-weight: 700; margin-bottom: 1.5rem; margin-top: 2rem; color: #111827;">Tech Stack</h2>
        
        <p style="margin-bottom: 0.5rem;">
          <strong style="font-weight: 600;">Frontend:</strong> React 18, TypeScript
        </p>
        <p style="margin-bottom: 0.5rem;">
          <strong style="font-weight: 600;">Backend:</strong> Node.js, Express, MongoDB, Firebase Auth
        </p>
        <p style="margin-bottom: 0.5rem;">
          <strong style="font-weight: 600;">AI/ML:</strong> OpenAI GPT-4o, Google Gemini API
        </p>
        <p style="margin-bottom: 0.5rem;">
          <strong style="font-weight: 600;">Infra:</strong> Docker, Railway, Resend API
        </p>
        <p style="margin-bottom: 2rem;">
          <strong style="font-weight: 600;">Billing:</strong> Polar (subscription + credits)
        </p>

        <hr style="border: none; border-top: 1px solid #e5e7eb; margin: 2rem 0;" />

        <h2 style="font-size: 1.5rem; font-weight: 700; margin-bottom: 1.5rem; margin-top: 2rem; color: #111827;">What I Learned</h2>
        
        <p style="margin-bottom: 0;">
          Building Dwriting as a solo full-stack developer taught me that the hardest part of an AI product isn't the AI — it's designing the right workflow around it. The 3-stage writing process, the peer feedback gamification, and the style learning system all required more product thinking than engineering. Shipping a bilingual, payment-integrated, AI-powered platform from zero validated my ability to own an entire product lifecycle.
        </p>
      </div>
    `,
    image: "/images/dwriting.ai-images/landing-page-ko.png",
    imageFiles: [
      "landing-page-ko.png",
      "main-dashboard-en.png",
      "main-dashboard-ko.png",
      "ai-feedback-ko.png",
      "growth-dashboard-en.png",
      "writing-300-en.png"
    ],
    tags: [
      "Full-Stack Development", "React", "TypeScript", "Node.js", "MongoDB",
      "AI Integration", "Google Gemini API", "Statistical Analysis", "Docker",
      "Production Deployment", "Real-time Analytics", "Machine Learning"
    ],
    isStudent: false,
    isComputer: true,
    featured: true,
    githubUrl: "https://github.com/luts83/dwriting-ai",
    liveUrl: "https://dwriting.ai",
    metrics: [
      { label: "Score Variance", value: "40%", improvement: "reduction" },
      { label: "Email Delivery", value: "98%", improvement: "60% → 98%" },
      { label: "Uptime", value: "99.9%" },
      { label: "Concurrent Users", value: "1000+" }
    ],
    challenges: [
      {
        problem: "AI evaluation scores were inconsistent",
        solution: "Implemented statistical outlier detection (standard deviation + IQR) and adaptive score limiting",
        impact: "Reduced score variance by 40%"
      },
      {
        problem: "SMTP blocking on Railway platform",
        solution: "Migrated to Resend API with exponential backoff retry logic",
        impact: "Improved email delivery rate from 60% to 98%"
      },
      {
        problem: "Users could submit duplicate content",
        solution: "Hash-based duplicate detection with MongoDB index optimization",
        impact: "Reduced duplicate submissions by 95%"
      },
      {
        problem: "Timezone-related bugs for global users",
        solution: "Centralized timezone utility functions with edge case handling",
        impact: "Eliminated all timezone-related bugs"
      }
    ],
    additionalImages: [
      "/images/dwriting.ai-images/main-dashboard-en.png",
      "/images/dwriting.ai-images/main-dashboard-ko.png",
      "/images/dwriting.ai-images/writing-300-ko.png",
      "/images/dwriting.ai-images/writing-1000-ko.png",
      "/images/dwriting.ai-images/ai-writing-essay-ko.png",
      "/images/dwriting.ai-images/ai-feedback-ko.png",
      "/images/dwriting.ai-images/growth-dashboard-en.png",
    ]
  },
  {
    id: 18,
    title: "Dwriting.ai User Behavior Analytics",
    category: "Data Analysis",
    date: "2026",
    location: "United Kingdom",
    description: "Analyzed production data to identify user growth patterns and achieved 100% accuracy in churn prediction using machine learning models.",
    descriptionText: `
      <div style="line-height: 1.7; color: #374151;">
        <p style="margin-bottom: 1rem;">
          Dwriting.ai User Behavior Analytics is a data analysis project that analyzes real user data from an AI-powered writing platform 
          to understand user behavior patterns, growth trends, and engagement levels.
        </p>
        
        <h3 style="font-size: 1.25rem; font-weight: 600; margin-bottom: 1rem; margin-top: 1.5rem; color: #111827;">Analysis Scale:</h3>
        <ul style="margin-left: 1.5rem; margin-bottom: 1.5rem;">
          <li style="margin-bottom: 0.5rem;">Submission Data: 1,196 entries</li>
          <li style="margin-bottom: 0.5rem;">Active Users: 99 users</li>
          <li style="margin-bottom: 0.5rem;">Feedback: 3,283 items</li>
          <li style="margin-bottom: 0.5rem;">Analysis Period: 2025-04-29 ~ 2026-02-21</li>
        </ul>
        
        <h3 style="font-size: 1.25rem; font-weight: 600; margin-bottom: 1rem; margin-top: 1.5rem; color: #111827;">Key Achievements:</h3>
        <ul style="margin-left: 1.5rem; margin-bottom: 1.5rem;">
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">Churn Prediction Accuracy: 100%</strong> - Random Forest model</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">3 User Segments Identified</strong> - K-Means clustering</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">Evaluation Consistency: 0.924</strong> - Cronbach's Alpha</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">13 Interactive Charts</strong> - Plotly-based visualizations</li>
        </ul>
        
        <h3 style="font-size: 1.25rem; font-weight: 600; margin-bottom: 1rem; margin-top: 1.5rem; color: #111827;">Analysis Content:</h3>
        <ul style="margin-left: 1.5rem; margin-bottom: 1.5rem;">
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">User Growth Pattern Analysis</strong>: Identified Fast Learners (14.3%), Steady Improvers (82.9%), and Plateau Users (2.9%) using K-Means clustering</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">Churn Prediction Model</strong>: Achieved 100% accuracy with Random Forest, with key predictors being active period (39.2%) and weekly activity (30.8%)</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">Retention Analysis</strong>: Generated weekly retention curves and analyzed engagement patterns</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">AI Evaluation System Validation</strong>: Validated evaluation consistency using statistical methods, detected outliers (7.0%)</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">Activity Pattern Analysis</strong>: Analyzed daily, weekly, and hourly user activity patterns</li>
        </ul>
        
        <h3 style="font-size: 1.25rem; font-weight: 600; margin-bottom: 1rem; margin-top: 1.5rem; color: #111827;">Tech Stack:</h3>
        <ul style="margin-left: 1.5rem; margin-bottom: 0;">
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">Language</strong>: Python 3.9+</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">Data Processing</strong>: Pandas, NumPy</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">Visualization</strong>: Plotly, Matplotlib, Seaborn</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">Machine Learning</strong>: Scikit-learn (K-Means, Random Forest)</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">Dashboard</strong>: Streamlit</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">Database</strong>: MongoDB, PyMongo</li>
          <li style="margin-bottom: 0.5rem;"><strong style="font-weight: 600;">Statistical Analysis</strong>: SciPy, Statsmodels</li>
        </ul>
      </div>
    `,
    image: "/images/optimized-images/data-analysis/dwriting-analytics/01.png",
    imageFiles: ["01.png"],
    tags: [
      "Data Analysis", "Machine Learning", "Python", "Streamlit",
      "MongoDB", "User Analytics", "K-Means", "Random Forest",
      "Plotly", "Pandas", "Scikit-learn"
    ],
    isStudent: false,
    isComputer: true,
    featured: true,
    hasAnalyticsDashboard: true,
    metrics: [
      { label: "Churn Prediction Accuracy", value: "100%" },
      { label: "Analysis Data", value: "1,196 submissions" },
      { label: "User Segments", value: "3 groups" },
      { label: "Evaluation Consistency", value: "0.924" }
    ],
    additionalImages: [
      "/images/optimized-images/data-analysis/dwriting-analytics/02.png",
      "/images/optimized-images/data-analysis/dwriting-analytics/03.png"
    ]
  }
];
